import React from 'react'
import LevelZeroHero from './levelZero/levelzerohero/LevelZeroHero'
import YourTeacher from './levelZero/yourteacher/YourTeacher'

const NeogLevelZero = () => {
  return (
    <div>
        <LevelZeroHero/>
        <YourTeacher/>
    </div>
  )
}

export default NeogLevelZero